<template>
  <div class="project-practice">
    <el-button
      class="settings-btn"
      size="small"
      type="primary"
      icon="el-icon-pie-chart"
      @click="$refs.Ratio.show = true"
      >权重设置</el-button
    >
    <div
      class="catalogue-item clearfix"
      v-for="item in catalogues"
      :key="item.id"
    >
      <div class="title">{{ item.name }}</div>
      <div class="btns">
        <el-button
          class="btn"
          size="mini"
          :type="status[item.openStr] ? 'danger' : 'success'"
          plain
          @click="handleChange(item.openStr)"
          >{{ status[item.openStr] ? "关闭项目" : "项目推送" }}</el-button
        >
        <el-button
          class="btn"
          size="mini"
          type="primary"
          plain
          @click="handleStart(item.label, item.initStr)"
          >开始实操</el-button
        >
      </div>
    </div>

    <Ratio ref="Ratio" />
  </div>
</template>

<script>
import { status, editStatus } from "@/api/projectPractice/common";
import Ratio from "./ratio.vue";
export default {
  components: { Ratio },
  data() {
    return {
      catalogues: [
        {
          id: 1,
          name: "项目一 团队组建",
          label: "buildTeam",
          openStr: "zjOpen",
          initStr: "dwGradeInit",
        },
        {
          id: 2,
          name: "项目二 账号定位",
          label: "accountLocation",
          openStr: "dwOpen",
          initStr: "dwGradeInit",
        },
        {
          id: 3,
          name: "项目三 账号搭建",
          label: "accountEstablish",
          openStr: "djOpen",
          initStr: "djGradeInit",
        },
        {
          id: 4,
          name: "项目四 文案创作",
          label: "copywriting",
          openStr: "waOpen",
          initStr: "waGradeInit",
        },
        {
          id: 5,
          name: "项目五 脚本创作",
          label: "scenario",
          openStr: "jbOpen",
          initStr: "jbGradeInit",
        },
        {
          id: 6,
          name: "项目六 视频拍摄",
          label: "videoShooting",
          openStr: "psOpen",
          initStr: "psGradeInit",
        },
        {
          id: 7,
          name: "项目七 视频剪辑",
          label: "videoClip",
          openStr: "jjOpen",
          initStr: "jjGradeInit",
        },
        {
          id: 8,
          name: "项目八 账号运营",
          label: "accountOperation",
          openStr: "yyOpen",
          initStr: "yyGradeInit",
        },
        {
          id: 9,
          name: "项目九 成果路演",
          label: "roadshow",
          openStr: "lyOpen",
          initStr: "lyGradeInit",
        },
        {
          id: 10,
          name: "项目十 数据分析",
          label: "analysis",
          openStr: "fxOpen",
        },
      ],
      status: {},
    };
  },
  created() {
    this.getStatus();
  },
  methods: {
    // 项目状态
    getStatus() {
      this.$loading.show();
      status({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.status = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改项目状态
    handleChange(prop) {
      let str = this.status[prop] ? "关闭项目" : "推送项目";
      this.$confirm(`确定要${str}吗?`, {
        type: "warning",
      })
        .then(() => {
          editStatus({
            classId: this.$route.query.id,
            open: !this.status[prop],
            prop,
          }).then((res) => {
            if (res.code == 0) {
              this.getStatus();
              this.$message.success(`${str}成功`);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleStart(label, initStr) {
      this.$router.push({
        path: `/classCourse/projectPractice/${label}`,
        query: { ...this.$route.query, isInit: this.status[initStr] },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.project-practice {
  position: relative;
  // background-color: #fff;
  .settings-btn {
    position: absolute;
    top: -43px;
    left: 120px;
  }
  .catalogue-item {
    margin-bottom: 20px;
    line-height: 38px;
    background-color: #f0f7ff;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
    .title {
      float: left;
      padding: 0 20px;
      font-size: 17px;
      color: #303133;
      font-weight: bold;
    }
    .btns {
      float: right;
      margin-right: 10px;
    }
  }
}
</style>